import { render } from "./ConfirmAlert.vue?vue&type=template&id=5c67c70a"
import script from "./ConfirmAlert.vue?vue&type=script&lang=js"
export * from "./ConfirmAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__